import { ReactNode } from "react";
import "./Content.css";
import { BottomWave, TopWaveDefault } from "./Waves";
import styled from "styled-components";
import { BackgroundEnum } from "../Enums/ThemeEnums";
import { StyledFlexConteiner } from "./StyledComponents/Containers";

interface StyledContentProps {
  bg: string;
  width?: string;
  height?: string;
}

const StyledContent = styled(StyledFlexConteiner).attrs(() => ({
  className: "content",
  $flex_direction: "column",
  $jc: "flex-start",
  margin: "auto",
}))<StyledContentProps>`
  background: ${({ bg }) => bg};
  width: ${({ width = "1280px" }) => width};
  height: ${({ height = "auto" }) => height};
`;

export const Content: React.FC<{
  children: ReactNode;
  withTopWave?: boolean;
  withBottomWave?: boolean;
  width?: string;
  height?: string;
  bg?: BackgroundEnum;
}> = ({
  children,
  withTopWave = true,
  withBottomWave = true,
  width,
  height,
  bg = BackgroundEnum.white,
}) => {
  return (
    <StyledContent bg={bg} width={width} height={height}>
      {withTopWave && <TopWaveDefault></TopWaveDefault>}
      {children}
      {withBottomWave && <BottomWave></BottomWave>}
    </StyledContent>
  );
};
